import {Component, Input, OnInit} from '@angular/core';

import {Contact} from '../../../../model/contact';
import {Contract} from '../../../../model/contract';

@Component({
    selector: 'app-contract-associated-users',
    imports: [],
    templateUrl: './contract-associated-users.component.html',
    styleUrl: './contract-associated-users.component.scss'
})
export class ContractAssociatedUsersComponent implements OnInit {
  @Input('contacts') contacts: Contact[];
  @Input('contract') contract: Contract;

  c: Contact[] = [];

  ngOnInit(): void {
    this.c = this.contacts.filter(contact => {
      return contact.contracts.some(contract => {
        return contract.crmId === this.contract.crmId;
      });
    });
  }

}
